import React from 'react';
import PropTypes from 'prop-types';
import './BarCard.scss';

const BarCard = ({ handleClass = '', backgroundColor = 'bg-light', children }) => {
    return (
        <div className="row">
            <div className="col-12">
                <div className={`bar-card ${backgroundColor}`}>
                    <div className={`handle ${handleClass}`}>&nbsp;</div>
                    <div className="content">{children}</div>
                </div>
            </div>
        </div>
    );
};

BarCard.propTypes = {
    handleClass: PropTypes.string, // success, warning, danger, info - uses task status colors
    backgroundColor: PropTypes.string, // default "bg-light" if null, also accepts "bg-white" or other Bootstrap background utilities
    children: PropTypes.oneOfType([
        PropTypes.array,
        PropTypes.element,
    ]),
};

export default BarCard;
